var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documentIcon_svg__clip0_10875_67943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33.135h7.122L13.934 4.6v11.377c0 1.041-.847 1.888-1.886 1.888H2.33a1.89 1.89 0 01-1.887-1.888V2.022A1.89 1.89 0 012.33.135zm0 16.575h9.718c.402 0 .73-.328.73-.732l-.027-10.92-2.422.008a1.31 1.31 0 01-1.31-1.309V1.285l-6.688.007a.732.732 0 00-.731.73v7.247c.008.186.005.686.002 1.116l-.002.496v1.88l.002.443c.003.368.006.797-.002 1.17v1.604c0 .404.328.732.73.732zm1.968-9.053a.537.537 0 000 1.075h5.91a.537.537 0 000-1.075h-5.91zm-.537 2.686c0-.296.24-.537.537-.537h5.91a.537.537 0 010 1.075h-5.91a.537.537 0 01-.537-.538zm.537 1.612a.537.537 0 100 1.075h5.91a.537.537 0 000-1.075h-5.91z",
    fill: "url(#documentIcon_svg__paint0_linear_10875_67943)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "documentIcon_svg__paint0_linear_10875_67943",
    x1: 13.934,
    y1: 17.866,
    x2: 0.444,
    y2: 17.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#98D3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#92E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DECE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "documentIcon_svg__clip0_10875_67943"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .135)",
    d: "M0 0h13.97v17.731H0z"
  })))));
}

export default SvgDocumentIcon;